'use strict';

angular.module('app')
    .factory('Recipe', ['$resource', 'ME_CONFIG', 'ConfigService', function ($resource, ME_CONFIG, ConfigService) {
        return $resource(ME_CONFIG.apiBaseUrl + '/recipes/:id', {}, {
            // Override the default query operation so we can transform the
            // result data by filtering out inactive recipes.
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (!data) {
                        return [];
                    }

                    // ME-5464
                    var unit = ConfigService.getRestaurantUnit();
                    var tenantId = unit && parseInt(unit.id) || 0;
                    var rejectionFunction = function (recipe) {
                        return recipe.inactive ||
                            (recipe.restrictTenants &&
                                recipe.restrictiveRestaurantUnits &&
                                recipe.restrictiveRestaurantUnits.indexOf(tenantId) === -1);
                    };
                    return _.reject(angular.fromJson(data), rejectionFunction);
                }
            },
            'queryMethod': {
                method: 'GET',
                isArray: false,
                url: ME_CONFIG.apiBaseUrl + '/recipeMethod/:id',
                transformResponse: function (data) {
                    if (!data) {
                        return {};
                    }
                    return angular.fromJson(data);
                }
            }
        });
    }])
    .service('RecipeService', ['$translate', function ($translate) {
        var categories = [{
            id: '',
            name: 'All',
            translationKey: 'recipeViewer.type.categoryTypes.ALL.value'
        }, {
            id: 'MENU',
            name: 'Menu Items',
            translationKey: 'recipeViewer.type.categoryTypes.MENU.value'
        }, {
            id: 'BAR',
            name: 'Bar Items',
            translationKey: 'recipeViewer.type.categoryTypes.BAR.value'
        }, {
            id: 'PREPARED',
            name: 'Prepared Items',
            translationKey: 'recipeViewer.type.categoryTypes.PREPARED.value'
        }];

        var getCategories = function () {
            return categories;
        };
        this.getCategories = getCategories;

        var getFriendlyCategoryName = function (c) {
            var cat = c && _.find(categories, {id: c});
            return cat && $translate.instant(cat.translationKey);
        };
        this.getFriendlyCategoryName = getFriendlyCategoryName;

        var scales = [{
            id: .25,
            name: '1/4',
            value: .25
        }, {
            id: .5,
            name: '1/2',
            value: .5
        }, {
            id: .75,
            name: '3/4',
            value: .75
        }, {
            id: 1,
            name: '1',
            value: 1
        }, {
            id: 2,
            name: '2x',
            value: 2
        }, {
            id: 3,
            name: '3x',
            value: 3
        }, {
            id: 4,
            name: '4x',
            value: 4
        }, {
            id: 'other',
            name: 'Other',
            translationKey: 'recipeViewer.scales.other',
            value: 1
        }];

        var getScales = function () {
            return scales;
        };
        this.getScales = getScales;

        var shelfLifeUnits = [{
            id: "HOUR",
            name: "Hours",
            translationKeySingular: 'recipeViewer.shelfLifeUnits.singular.hour',
            translationKeyPlural: 'recipeViewer.shelfLifeUnits.plural.hour'
        }, {
            id: "DAY",
            name: "Days",
            translationKeySingular: 'recipeViewer.shelfLifeUnits.singular.day',
            translationKeyPlural: 'recipeViewer.shelfLifeUnits.plural.day'
        }, {
            id: "WEEK",
            name: "Weeks",
            translationKeySingular: 'recipeViewer.shelfLifeUnits.singular.week',
            translationKeyPlural: 'recipeViewer.shelfLifeUnits.plural.week'
        }];

        var restrictedTenantFilter = function (allRecipes, restaurantUnit) {
            var notRestrictedRecipes = [];
            _.forEach(allRecipes, function (r) {
                if (!r.restrictTenants || (r.restrictiveRestaurantUnits.indexOf(restaurantUnit) > -1)) {
                    notRestrictedRecipes.push(r);
                }
            });
            return notRestrictedRecipes;
        };
        this.restrictedTenantFilter = restrictedTenantFilter;

        var getRecipeShelfLife = function (item) {
            if (!(item && item.shelfLifeQuantity && item.shelfLifeUnit)) {
                return '';
            }

            var unit = _.find(shelfLifeUnits, {id: item.shelfLifeUnit});
            var friendly = item.shelfLifeQuantity !== 1 ? $translate.instant(unit.translationKeyPlural) : $translate.instant(unit.translationKeySingular);
            return item.shelfLifeQuantity + ' ' + friendly;
        };
        this.getRecipeShelfLife = getRecipeShelfLife;
    }])
    .filter('recipeCategoryFilter', ['RecipeService', function (RecipeService) {
        return RecipeService.getFriendlyCategoryName;
    }])
    .filter('recipeShelfLifeFilter', ['RecipeService', function (RecipeService) {
        return RecipeService.getRecipeShelfLife;
    }]);